import { useState, useContext, useEffect, useRef } from "react";
import style from "@styles/profile/transaction.module.css";
import Image from "next/legacy/image";
import dPicture from "@public/assets/images/committee.png";
import { useMediaQuery } from "@mui/material";
import { IoMdMore } from "react-icons/io";
import { downloadReceipt } from "@queries/events.queries";
import { Store } from "@utils/store/ContextStore";
import EnterMail from "@components/modal/EnterMail";
import { useRouter } from "next/router";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
function Description({
  data
}) {
  const smallScreen = useMediaQuery("(max-width:600px)");
  if (!smallScreen) {
    return <>
        <span className={style.tInfoDesc}>
          {data?.CommunityEvent?.description.length > 50 ? `${data?.CommunityEvent?.description.slice(0, 50)}...` : data?.CommunityEvent?.description}
        </span>
      </>;
  }
  return <>
      <span className={style.tInfoDesc}>{`${data?.CommunityEvent?.description.slice(0, 30)}...`}</span>
    </>;
}
const TItems = ({
  data,
  onClickHandler,
  userDetail
}) => {
  const [showMore, setShowMore] = useState(false);
  const {
    state
  } = useContext(Store);
  const user = state?.user;
  const [url, setUrl] = useState(null);
  const [openMailModal, setOpenMailModal] = useState(false);
  const [regID, setRegID] = useState(null);
  const router = useRouter();
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const handleMore = () => {
    setShowMore(!showMore);
  };
  const ReceiptDownload = async () => {
    const res = await downloadReceipt({
      registrationID: data?.registrationID,
      accessToken: user?.accessToken
    });
    if (!res.data) {
      setErrorModal({
        open: true,
        heading: "Error",
        message: "Something Went Wrong! Please Try Again Later",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return;
    } else {
      setUrl(res.data);
      window.open(res.data, "_blank");
    }
    setShowMore(!showMore);
  };
  const getTaxInvoice = async () => {
    setOpenMailModal(!openMailModal);
  };
  const ref = useRef();
  useEffect(() => {
    const handleClickOutside = event => {
      if (!ref?.current?.contains(event.target)) {
        setShowMore(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [ref]);
  return <>
      <div className={`${style.tInfoDiv}  ${router?.query?.registrationID ? style.queryBg : ""}`}>
        <div className={style.tInfoLBx} onClick={onClickHandler}>
          <Image src={data?.CommunityEvent?.images[0] || dPicture} alt={`${data?.CommunityEvent?.name} dp`} width="50" height="50" objectFit="cover" className={style.tInfoImg} data-sentry-element="Image" data-sentry-source-file="TItems.jsx" />
          <div className={style.tInfoND}>
            <span className={style.tInfoName}>
              {data?.CommunityEvent?.name}
            </span>
            {/* <Description data={data}/> */}
            <span className={style.tInfoDesc}>{data?.Community?.name}</span>
          </div>
        </div>
        <div className={style.tInfoRBx}>
          <span className={style.tInfoUPaid}>₹{data?.amount}</span>
          <button className={style.more} m onClick={handleMore}>
            <IoMdMore data-sentry-element="IoMdMore" data-sentry-source-file="TItems.jsx" />
          </button>
        </div>

        {showMore && <div className={style.dropdown} ref={ref}>
            <button className={style.dropdownItem} onClick={ReceiptDownload}>
              Download Receipt
            </button>
            <button className={style.dropdownItem} onClick={getTaxInvoice}>
              Get Tax Invoice
            </button>
          </div>}
      </div>

      {openMailModal && <EnterMail open={openMailModal} onClose={() => {
      setOpenMailModal(false);
    }} registrationID={data?.registrationID} userDetail={userDetail} />}
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg="Okay" onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </>;
};
export default TItems;